import { I18n } from "@/i18n/I18n";
import { useState } from "react";
import { Container } from "@/backend/models/containers/container";
import { BasicButton } from "../buttons/BasicButton";
import { Block } from "@/backend/models/block";
import { BlockModal } from "./BlockModal";
import { ProcedureInstanceBase } from "@/backend/models/procedureInstances/procedureInstanceBase";
import { ImplementationFunction } from "@/backend/models/implementationFunction";


export function AddBlockButton(props: { parent: Container | Block | ProcedureInstanceBase | ImplementationFunction, position: number, isScaffold?: boolean }) {
  const { parent, position, isScaffold } = props;
  const [show, setShow] = useState(false);

  return (
    <>
      { show && <BlockModal setShow={setShow} parent={parent} position={position} isScaffold={isScaffold} /> }
      <BasicButton className='btn btn-sm btn-primary' onClick={() => setShow(true)} label={I18n.get('addBlock')} />
    </>
  );
 }
